import React, { useEffect, useState } from "react";
import { getFromDB } from "../../indexedDB/indexedDB";

const GetScore = ({ quiz, quizItemSet, refresh }) => {
  const [returnValue, setReturnValue] = useState("");

  useEffect(() => {
    setReturnValue("0");
    // Bepaal quizItemId op basis van quizItemSet
    let currentQuizItemId = "";
    if (
      quizItemSet.external_game === false &&
      quizItemSet.result_quiz_item_id !== ""
    ) {
      currentQuizItemId = quizItemSet.result_quiz_item_id;
    } else if (
      quizItemSet.external_game === false &&
      quizItemSet.result_quiz_item_id === ""
    ) {
      currentQuizItemId = quizItemSet.quiz_item_id;
    } else if (quizItemSet.external_game === true) {
      currentQuizItemId = quizItemSet.result_quiz_item_id;
    }

    // if (currentQuizItemId !== "extern") {
      const fetchAnswersScore = async () => {
        const dbName =
          sessionStorage.getItem("currentSessionName") || "Leerling";
        try {
          const data = await getFromDB(dbName);

          const dataItem = data.find((item) => item.id === currentQuizItemId);


          if (dataItem) {
            quiz.Quizes.forEach((quizItem) => { // Gebruik forEach in plaats van map als je niet de geretourneerde array gebruikt
                if(quizItem.quiz_item_id === dataItem.id){
                    setReturnValue("0");

              if (quizItem.__component === "quiz-game-types.sorteer") {
                const correctOrder = quizItem.sorteer_items.map(item => item.id);
                const givenOrder = dataItem.answer.map(item => item.id);

                const allCorrect =
                  JSON.stringify(correctOrder) === JSON.stringify(givenOrder);

                if (allCorrect) { 
                  setReturnValue("1");
                }else {
                  setReturnValue("0");
                }
              } else if (quizItem.__component === "quiz-game-types.stelling") {
                const correctAnswersIds = quizItem.Antwoord_items
                  .filter(item => item.is_correct_answer)
                  .map(item => item.id.toString());

                const allCorrect = dataItem.answer.every(ans =>
                  correctAnswersIds.includes(ans.toString())
                );

                if (allCorrect) { 
                    setReturnValue("1");
                  }else {
                    setReturnValue("0");
                  }
              } else if (quizItem.__component === "quiz-game-types.open-vragen") {
                const givenAnswer = dataItem.answer;
                const allCorrect = givenAnswer !== '' ? true : false;
                if (allCorrect) { 
                    setReturnValue("1");
                  }else {
                    setReturnValue("0");
                  }
              } else if (quizItem.__component === "quiz-game-types.comunictating-iframe") {
                const givenAnswer = dataItem.answer;
                const allCorrect = !!givenAnswer;
                if (allCorrect) { 
                    setReturnValue("1");
                  }else {
                    setReturnValue("0");
                  }
              }
            }
            });
          }
        } catch (error) {
          console.error("Error fetching answers from DB:", error);
        }
      };

      fetchAnswersScore();
    // } else {
    //   setReturnValue("extern");
    // }
  }, [quiz, quizItemSet, refresh]); // Voeg `quizItemSet` toe aan de dependency array

  return <>{returnValue}/1</>;
};

export default GetScore;
